/* unplugin-vue-components disabled */import { render } from "./docs-list.vue?vue&type=template&id=c1f65620&scoped=true"
import script from "./docs-list.vue?vue&type=script&setup=true&lang=js"
export * from "./docs-list.vue?vue&type=script&setup=true&lang=js"

import "./docs-list.vue?vue&type=style&index=0&id=c1f65620&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f65620"],['__file',"src/controls/docs-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1f65620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1f65620', __exports__)) {
    api.reload('c1f65620', __exports__)
  }
  
  module.hot.accept("./docs-list.vue?vue&type=template&id=c1f65620&scoped=true", () => {
    api.rerender('c1f65620', render)
  })

}


export default __exports__